import { ImageEdit } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import TextInput from "@pathwright/ui/src/components/form/form-text-input/TextInput"
import React from "react"
import QuestionHeader from "../Question/QuestionHeader"
import { AnnotatedImageWrapper, QuestionWrapper } from "./ui"

const AnnotatedAssessmentEdit = (props) => {
  const { onChange, blockStyles, data } = props

  const [image, setImage] = React.useState(data.src)
  const [altText, setAltText] = React.useState(data.altText)
  const [caption, setCaption] = React.useState(data.caption)
  const [annotations, setAnnotations] = React.useState(data.options)
  const [requiredCount, setRequiredCount] = React.useState(data.requiredCount)

  const handleChangeImage = (image, altText) => {
    setImage(image)
    setAltText(altText)

    onChange({
      src: image,
      altText: altText || "Image block"
    })
  }

  const handleChangeCaption = (caption) => {
    setCaption(caption)
    onChange({ caption })
  }

  const handleChangeAnnotations = (options) => {
    setAnnotations(options)
    onChange({ options })
  }

  const handleChangeRequiredCount = (value) => {
    const requiredCount = Number(value)
    setRequiredCount(requiredCount)
    onChange({ requiredCount })
  }

  const imageProps = {
    image,
    altText,
    caption,
    annotations,
    onChangeImage: handleChangeImage,
    onChangeCaption: handleChangeCaption,
    onChangeAnnotations: handleChangeAnnotations
  }

  return (
    <Content.Container>
      <QuestionWrapper blockStyles={blockStyles}>
        <QuestionHeader {...props} />
        <div
          className="annotation-number"
          style={{ display: "flex", alignItems: "center" }}
        >
          <p>How many annotations (0 for no requirement):</p>
          <TextInput
            value={requiredCount || 0}
            onChange={handleChangeRequiredCount}
            autoSize
            type="text"
          />
        </div>
      </QuestionWrapper>
      <AnnotatedImageWrapper>
        <ImageEdit
          className="AnnotatedImageEdit"
          {...imageProps}
          // annotationsEnabled
          captionEnabled
        />
      </AnnotatedImageWrapper>
    </Content.Container>
  )
}

export default AnnotatedAssessmentEdit
